import React, { useEffect, useState } from "react";
import { View, Text } from "react-native";
import { FormattedMessage } from "react-intl";
import GoBackButton from "../../components/GoBackButton";
import HeaderTabs from "../../components/HeaderTabs";
import AuthCodeInput from "../../components/Form/AuthCodeInput";

import styles from "./styles";
import userService from "../../services/userService";
import { useRoute } from "@react-navigation/core";
import toast from "../../utils/toast";
import AsyncStorage from "@react-native-async-storage/async-storage";

const NewPassword = ({ navigation }) => {
  const route = useRoute();

  const [password, setPassword] = useState("");

  const [currentPassword, setCurrentPassword] = useState(
    route.params?.password
  );

  useEffect(() => {
    resetPassword();
  }, [password]);

  const resetPassword = async () => {
    if (password.length === 6) {
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      userService
        .changePassword(token, currentPassword, password)
        .then((response) => {
          if (response.status == 200) {
            toast(response.data.message, "green");
            navigation.navigate("MyAccount");
          } else {
            handleError(response.data);
          }
        })
        .catch((error) => {
          handleError(error?.response?.data);
        });
    }
  };

  const handleError = (data) => {
    if (data?.message) {
      toast(data.message, "#DA1414");
    } else {
      toast(
        intl.formatMessage({ id: "newPassword.erroAtualizaSenha" }),
        "#DA1414"
      );
    }
  };

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="changePassword.titleTrocarSenha" />}
      />

      <View style={styles.container}>
        <View style={{ marginBottom: 12 }}>
          <Text style={styles.tittleTrocarSenha}>
            <FormattedMessage id="changePassword.titleTrocarSenha" />
          </Text>
        </View>
        <FormattedMessage id="newPassword.msgDigiteNovaSenha">
          {(label) => (
            <AuthCodeInput
              cellCount={6}
              isPassword={true}
              value={password}
              onValueChange={(value) => setPassword(value)}
              label={label}
            />
          )}
        </FormattedMessage>
        <View style={{ marginTop: 20 }}>
          <GoBackButton />
        </View>
      </View>
    </>
  );
};

export default NewPassword;
